module.exports = __webpack_public_path__ + "assets/img/car14.c49b19f3.jpg";